import React, { useState, useEffect } from "react";
import "./index.css";
import { FaTools } from "react-icons/fa";
import QRCodeScanner from "../../components/Qrcode";
import Header from "../../components/Header";
import Select from 'react-select'
import ModalAlert from '../../components/ModalAlert/modal'
import { FaRegCircleXmark } from "react-icons/fa6";
import Modal from "react-modal";
import { MdQrCodeScanner } from "react-icons/md";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import secureLocalStorage from "react-secure-storage";
import { FcFilledFilter } from "react-icons/fc";
import { FaFilter } from "react-icons/fa"; // FaFilterSlash é um exemplo, você pode escolher outro ícone
import { MdFilterAltOff } from "react-icons/md";
import ModalIncluirNovo from '../../components/ModalIncluirNovo/modal'
import { isMobile } from "react-device-detect";
import api from '../../Services/api'
import { AxiosResponse } from "axios";
import Loading from '../../components/Loading/index'
import axios from 'axios';
import { useNavigate } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import { FaCheckCircle } from "react-icons/fa";
import InputCustTask from '../../components/InputCustTask'

interface ContratoRaw {
  ctc_id: number;
  ctc_description: string;
  [key: string]: any; // se tiver mais campos e quiser ignorar o resto
}

interface ContratoAgrupado {
  ctc_id: number;
  ctc_description: string;
}

interface UnidadeAgrupado {
  unt_id: number;
  unt_description: string;
}

type OptionType = { value: string; label: string };

interface DadosCompleto {
  ctc_id: number;
  ctc_description: string;
  unt_id: number;
  unt_description: string;
}


interface Portalparameters {
  ppr_id: number;
  ppr_allowshipping: number;
  ppr_directionmanual: number;
  age_id: number;
  tea_id: number;
  stn_id: number;
  ppr_allowcustomfields: number;
}

type OptionTipoSolicitacao = {
  label: string;
  value: string;
};

type PavimentoOption = {
  value: string;
  label: string;
};

interface Local {
  loc_id: number;
  loc_active: number;
  loc_description: string;
  loc_alternativeidentifier: string;
  loc_pavement: string;
  unt_id: number;
  ctc_id: number;
  lty_id: number;
  age_id_insert: number | null;
  loc_datetimeinsert: string;
  age_id_lastupdate: number | null;
  loc_datetimeupdate: string;
  loc_phoneddd: string | null;
  loc_phoneddi: string | null;
  loc_phone: string | null;
  loc_mobilephoneddd: string | null;
  loc_mobilephoneddi: string | null;
  loc_mobilephone: string | null;
  loc_email: string | null;
  loc_observation: string | null;
  loc_mobilecode: string | null;
  loc_integrationid: string | null;
  loc_responsibletechnician: string | null;
}

export interface AssetWithLocation {
  ast_id: number;
  ast_active: number;
  ast_description: string;
  pdc_id: number;
  inc_id: number | null;
  ssa_id: number | null;
  ast_observation: string | null;
  ast_datetimeinsert: string;
  ast_datetimeupdate: string;
  loc_id: number;
  ast_usedby: string | null;
  ast_serialnumber: string | null;
  ast_mac: string | null;
  ast_tombamento: string | null;
  ast_residualvalue: number | null;
  dpc_id: number | null;
  ast_expirationdate: string | null;
  ast_cust: number | null;
  ast_invoicenumber: string | null;
  ast_issuedate: string | null;
  ast_warrantyyear: number | null;
  ast_warrantymonth: number | null;
  ast_alternativeidentifier: string | null;
  sta_id: number | null;
  age_id_insert: number | null;
  age_id_lastupdate: number | null;
  ast_costcenter: string | null;
  ast_mobilecode: string | null;
  ast_integrationid: string | null;
  loc_active: number;
  loc_description: string;
  loc_alternativeidentifier: string | null;
  loc_pavement: string | null;
  unt_id: number;
  ctc_id: number;
  lty_id: number;
  loc_datetimeinsert: string;
  loc_datetimeupdate: string;
  loc_phoneddd: string | null;
  loc_phoneddi: string | null;
  loc_phone: string | null;
  loc_mobilephoneddd: string | null;
  loc_mobilephoneddi: string | null;
  loc_mobilephone: string | null;
  loc_email: string | null;
  loc_observation: string | null;
  loc_mobilecode: string | null;
  loc_integrationid: string | null;
  loc_responsibletechnician: string | null;
}


const Chamados: React.FC = () => {

  const navigate = useNavigate();

  const [empresa, setEmpresa] = useState('');
  const [solicitante, setSolicitante] = useState('');
  const [telefone, setTelefone] = useState('');
  const [ativo, setAtivo] = useState('');
  const [descricaoAtivo, setDescricaoAtivo] = useState('');
  const [observacao, setObservacao] = useState('');
  const [local, setLocal] = useState('');
  const [contrato, setContrato] = useState('');
  const [unidade, setUnidade] = useState('');
  const [andar, setAndar] = useState('');
  const [localFiltro, setLocalFiltro] = useState('');
  const [entidade, setEntidade] = useState('');
  const [tipoSolicitacao, setTipoSolicitacao] = useState('');
  const [localDestino, setLocalDestino] = useState('');

  const [optionTipoSolicitacao, setOptionTipoSolicitacao] = useState<OptionTipoSolicitacao[]>([])

  //    { value: '3', label: 'Movimentação' },

  const [optionLocal, setOptionLocal] = useState([]);
  const [optionLocalComp, setOptionLocalComp] = useState([]);
  const [dadosCompletos, setDadosCompletos] = useState<DadosCompleto[]>([]);
  const [portalparameters, setPortalparameters] = useState<Portalparameters[]>([]);
  const [optionLocalCompleto, setOptionLocalCompleto] = useState([]);
  const [optionLocalAtual, setOptionLocalAtual] = useState<Local[]>([]);
  const [optionContrato, setOptionContrato] = useState<OptionType[]>([]);
  const [optionUnidade, setOptionUnidade] = useState<OptionType[]>([]);
  const [optionAndar, setOptionAndar] = useState([]);
  const [dadosCampoCust, setDadosCampoCust] = useState([]);

  const [optionAtivo, setOptionAtivo] = useState([]);
  const [optionAtivoComp, setOptionAtivoComp] = useState([]);
  const [optionAtivoCompleto, setOptionAtivoCompleto] = useState([]);
  const [optionAtivoAtual, setOptionAtivoAtual] = useState<AssetWithLocation[]>([]);

  const [openModal, setOpenModal] = useState(false)
  const [openModalFilter, setOpenModalFilter] = useState(false)
  const [qualAlert, setQualAlert] = useState(<></>)
  const [tabIndex, setTabIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openModalIncluirNovo, setOpenModalIncluirNovo] = useState(false)
  const [openModalIncluirNovo2, setOpenModalIncluirNovo2] = useState(false)
  const [qualTitulo, setQualTitulo] = useState('')
  const [qrCodeValue, setQrCodeValue] = useState("");

  const [isDisabledContrato, setIsDisabledContrato] = useState(false)

  const optionEmpresa = [{ value: '1', label: 'Equipe Interna' }]
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [filtroAtivo2, setFiltroAtivo2] = useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string | null>(null);
  const [imagePreviewUrl2, setImagePreviewUrl2] = useState<string | null>(null);

  const [optionsAgent, setOptionsAgent] = useState([])
  const [optionsCorrectivetype, setOptionsCorrectivetype] = useState([])

  const [crt_id, setCrt_id] = useState('');
  const [age_id, setAge_id] = useState('');

  const[qualUnidade, setqualUnidade] = useState('');

  useEffect(() => {

    if (secureLocalStorage.getItem('pp') === null) {
      setQualAlert(<div className='div-alert'>
        <FaRegCircleXmark className="ControleIconAlertcancel" />
        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
        <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
        <div className='btn-alert' onClick={fecharModalToken}><span className="btn-alert-lab">OK</span></div>
      </div>)
      setOpenModal(true)
    } else {

      setQualAlert(<div className='div-alert'><Loading /></div>)
      setOpenModal(true)

      setSolicitante(secureLocalStorage.getItem('n') as '')
      setPortalparameters(secureLocalStorage.getItem('pp') as [])

      if (secureLocalStorage.getItem('paramsEntidade') === 'AST') {
        setEntidade('2')
        setTabIndex(1)
      } else if (secureLocalStorage.getItem('paramsEntidade') === 'LOC') {
        setTabIndex(0)
        setEntidade('1')
        setLocal(String(secureLocalStorage.getItem('https') || ''))
      } else {
        setEntidade('1')
        setTabIndex(0)
      }
      validatToken();
    }

  }, []);



  async function GetAgent() {
    let ret: AxiosResponse;
    let valor: any;
    try {
      ret = await api.get("user/listar")
      if (ret.data.status === 200) {
        valor = ret.data.data;

        const arr = valor
          .filter((user: any) => user.age_mobileuser === 1) // filtra só os mobileuser = 1
          .map((user: any) => ({
            value: String(user.age_id),
            label: user.age_name
          }));

        setOptionsAgent(arr)

      }
    } catch (e) {
      setOptionsAgent([])
    }
  }


  async function GetCorrectivetype(idtipo: any) {
    let ret: AxiosResponse;
    let valor: any;
    try {
      ret = await api.get("correctivetype/listarcorrectivetypeentity", {
        params: {
          id: idtipo
        }
      })
      if (ret.data.status === 200) {
        valor = ret.data.data;
        const arr = [] as any;
        let result = valor;

        result.map((user: any) => {
          return arr.push({ value: String(user.crt_id), label: user.crt_description });
        });

        setOptionsCorrectivetype(arr)

      }
    } catch (e) {
      setOptionsCorrectivetype([])
    }
  }

  async function validatToken() {

    let ret: AxiosResponse;
    let valor: any;

    const _user = secureLocalStorage.getItem('tpcm')

    api.defaults.headers.common['Authorization'] = _user as ''

    try {

      ret = await api.get("/status/validar")

      if (ret.data.status === 200) {

        const stored = secureLocalStorage.getItem('au');
        const tipoTarefa = secureLocalStorage.getItem('ttp');

        if (Array.isArray(tipoTarefa)) {
          const arr = [] as any;

          tipoTarefa.map((user: any) => {
            return arr.push({ value: String(user.tty_id), label: user.tty_description });
          });


          setOptionTipoSolicitacao(arr)

          if (arr.length === 1) {
            setTipoSolicitacao(arr[0].value)
          }

        }

        if (Array.isArray(stored)) {
          // Já é objeto, usado com React Secure Storage
          const validos = stored.filter((item: any): item is DadosCompleto =>
            typeof item.ctc_id === 'number' &&
            typeof item.ctc_description === 'string' &&
            typeof item.unt_id === 'number' &&
            typeof item.unt_description === 'string'
          );
          setDadosCompletos(validos);

          await GetLocal(validos);
          await GetContrato(validos);
          await GetAtivo(validos);

        }

        if (secureLocalStorage.getItem('aua') === 1) {
          await GetAgent()
          await GetCorrectivetype('1')
        }

        setOpenModal(false)

      } else {
        setOpenModal(false)
      }

    } catch (e: any) {

      if (e.response && e.response.status === 403) {
        setQualAlert(<div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
          <div className='btn-alert' onClick={fecharModalToken}><span className="btn-alert-lab">OK</span></div>
        </div>)
        setOpenModal(true)

      } else if (!e.response) {
        setQualAlert(<div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Sem comunicação com o servidor.</span></div>
          <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
        </div>)
        setOpenModal(true)

      } else {
        setQualAlert(<div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
          <div className='btn-alert' onClick={fecharModalToken}><span className="btn-alert-lab">OK</span></div>
        </div>)
        setOpenModal(true)
      }
    }

  }



  function fecharModalToken() {
    secureLocalStorage.removeItem('paramsEntidade')
    secureLocalStorage.removeItem('paramsQrcode')
    secureLocalStorage.removeItem('tpcm')
    secureLocalStorage.removeItem('acp')
    secureLocalStorage.removeItem('n')
    secureLocalStorage.removeItem('iag')
    secureLocalStorage.removeItem('https')
    navigate('/login');
    setOpenModal(false)
  }

  async function GetAtivo(obj: any) {
    let ret: AxiosResponse;
    let valor: any;
    try {
      ret = await api.get("asset/assetunidades", {
        params: {
          unidades: obj,
        }
      })
      if (ret.data.status === 200) {
        valor = ret.data.data;

        const arr = [] as any;
        let result = valor;
        result.map((user: any) => {
          return arr.push({ value: String(user.ast_id), label: user.ast_alternativeidentifier ? user.ast_description + " (" + user.ast_alternativeidentifier + ")" : user.ast_description });
        });


        const url = String(secureLocalStorage.getItem('https'));
        const updatedUrl = url.replace(/^https:/, 'http:');

        if (updatedUrl !== null && secureLocalStorage.getItem('paramsEntidade') === 'AST') {
          const qualAtv = valor.filter(
            (e: any) => {
              return e.ast_alternativeidentifier === updatedUrl
            }
          );

          setAtivo(String(qualAtv[0].ast_id))

        }

        setOptionAtivo(arr)
        setOptionAtivoComp(arr)
        setOptionAtivoCompleto(valor)
        setOptionAtivoAtual(valor)

      }
    } catch (e) {
      setOptionAtivo([])
      setOptionAtivoComp([])
    }
  }

  async function GetContrato(dadoscontrato: any) {

    const result: ContratoAgrupado[] = Object.values(
      dadoscontrato.reduce((acc: Record<number, ContratoAgrupado>, item: any) => {
        if (!acc[item.ctc_id]) {
          acc[item.ctc_id] = {
            ctc_id: item.ctc_id,
            ctc_description: item.ctc_description,
          };
        }
        return acc;
      }, {})
    );

    setOptionContrato(
      result.map((c) => ({ value: String(c.ctc_id), label: c.ctc_description }))
    );



    if (result.length === 1) {
      //setIsDisabledContrato(true);
      setContrato(String(result[0].ctc_id))
      await GetUnidade2(result[0].ctc_id, dadoscontrato)
    }


  }


  async function GetUnidade2(id: any, dadoscontrato: any) {

    const filtrados = dadoscontrato.filter((item: any) => item.ctc_id === id);

    const result: UnidadeAgrupado[] = Object.values(
      dadoscontrato.reduce((acc: Record<number, UnidadeAgrupado>, item: any) => {
        if (!acc[item.unt_id]) {
          acc[item.unt_id] = {
            unt_id: item.unt_id,
            unt_description: item.unt_description,
          };
        }
        return acc;
      }, {})
    );

    setOptionUnidade(
      result.map((c) => ({ value: String(c.unt_id), label: c.unt_description }))
    );

  }


  function IncluirContrato(id: any) {
    if (id === '') {
      setOptionUnidade([]);
      setOptionAndar([]);
      setOptionLocal([]);
      setContrato('');
      setUnidade('');
      setAndar('');
      setLocal('');
      setLocalFiltro('');
    } else {
      setOptionLocal([]);
      setOptionUnidade([]);
      setOptionAndar([]);
      setAndar("")
      setUnidade('');
      setLocal('');
      setLocalFiltro('');

      GetUnidade(id);
      setContrato(id);
    }
  }

  async function GetUnidade(id: any) {

    const filtrados = dadosCompletos.filter((item: any) => String(item.ctc_id) === String(id));

    const result: UnidadeAgrupado[] = Object.values(
      filtrados.reduce((acc: Record<number, UnidadeAgrupado>, item: any) => {
        if (!acc[item.unt_id]) {
          acc[item.unt_id] = {
            unt_id: item.unt_id,
            unt_description: item.unt_description,
          };
        }
        return acc;
      }, {})
    );

    setOptionUnidade(
      result.map((c) => ({ value: String(c.unt_id), label: c.unt_description }))
    );

  }

  function IncluirUnidade(id: any) {
    if (id === '') {
      setOptionAndar([]);
      setUnidade('');
      setAndar('');
    } else {
      setOptionAndar([]);
      setAndar('');
      GetPavimento(id);
      setUnidade(id);
    }
  }

  async function GetPavimento(unidade: any) {
    setQualAlert(<div className="div-alert"><Loading /></div>);
    setOpenModal(true);

    try {
      const ret = await api.get("local/listar", {
        params: { id: unidade }
      });

      if (ret.data.status === 200) {
        const valor: any[] = ret.data.data;

        // 🔑 filtro ajustado
        const filteredData = valor.filter((item) => {
          const pav = item.loc_pavement?.toLowerCase() || "";
          return (
            !pav.includes("checklist") &&
            !pav.includes("unimed") &&
            !pav.includes("unidade") &&
            !pav.includes("bebedouro")
          );
        });


        const sortedArr: PavimentoOption[] = filteredData
          .map((user: any) => ({
            value: user.loc_pavement as string,
            label: user.loc_pavement as string,
            order: extractOrder(user.loc_pavement)
          }))
          .sort((a, b) => {
            if (a.order === b.order) {
              return a.label.localeCompare(b.label);
            }
            return a.order - b.order;
          })
          .map(({ value, label }) => ({ value, label }));

        setOptionAndar(sortedArr as any);
      } else {
        setOptionAndar([]);
      }
    } catch (e) {
      setOptionAndar([]);
    } finally {
      setOpenModal(false);
    }
  }


  function extractOrder(pavement: string): number {
    const matchAndar = pavement.match(/^(\d+)º?/);
    if (matchAndar) return parseInt(matchAndar[1]);

    const matchG = pavement.match(/^G(\d+)/);
    if (matchG) return 100 + parseInt(matchG[1]);

    const matchM = pavement.match(/^M(\d+)/);
    if (matchM) return 200 + parseInt(matchM[1]);

    if (pavement.toUpperCase().includes('TÉRREO')) return 300;

    return 1000;
  }


  async function GetLocal(obj: any) {
    let ret: AxiosResponse;
    let valor: any;
  

    try {
      ret = await api.get("local/localunidades", {
        params: { unidades: obj },
      });
  
      if (ret.data.status === 200) {
        valor = ret.data.data;
  
        // 🔹 Palavras proibidas
        const palavrasBloqueadas = ["EQUIPAMENTOS - ", "CHECKLIST", "UNIMED", "UNIDADE", "BEBEDOURO", "BOMBA", "QUADRO", "HIDRÁULICA", "VERIFICAR", "TORNEIRA", "VERIFICAÇÃO"];
  
        // 🔹 Filtra removendo os itens que contenham as palavras no loc_description
        const filtrado = valor.filter(
          (user: any) =>
            !palavrasBloqueadas.some((palavra) =>
              user.loc_description.toLowerCase().includes(palavra.toLowerCase())
            )
        );
  
        const arr = filtrado.map((user: any) => ({
          value: String(user.loc_id),
          label: `${user.loc_description} (${user.loc_alternativeidentifier})`
        }));
  
        // 🔹 Ordena em ordem alfabética pelo label
        arr.sort((a: any, b: any) =>
          a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
        );
  
        const ambiente = String(secureLocalStorage.getItem("tp") || "")
   
        if(ambiente === 'SABARA' && arr.length === 1){
            setLocal(arr[0].value)
        }

        setOptionLocal(arr);
        setOptionLocalComp(arr);
        setOptionLocalCompleto(valor);
        setOptionLocalAtual(valor);

        const url = String(secureLocalStorage.getItem("https"));
  
        if (secureLocalStorage.getItem("paramsEntidade") === "LOC") {
          const qualAtv = valor.filter(
            (e: any) => e.loc_alternativeidentifier === url
          );
  
          if (qualAtv.length > 0) {
            setLocal(String(qualAtv[0].loc_id));
          }
        }
      } else {
        setOptionLocalComp([]);
        setOptionLocal([]);
      }
    } catch (e) {
      setOptionLocal([]);
    }
  }
  

  function incluirLocal(id: any) {

    if (id === '') {
      setLocal('')
      setOptionLocal(optionLocalComp)
    } else {

      const onde = optionLocalAtual.find(
        (e: any) => String(e.loc_id) === String(id)
      );

      setqualUnidade(String(onde?.unt_id));
      
      setLocal(id)  
    }

  }

  async function GetLocalAndar() {
    let ret: AxiosResponse;
    let valor: any;

    setQualAlert(<div className='div-alert'><Loading /></div>)
    setOpenModal(true)

    if (contrato === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o contrato.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (unidade === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o unidade.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (andar === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o andar.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else {

      try {
        ret = await api.get("local/listarlocpaviment", {
          params: {
            id: unidade,
            paviment: andar,
          },
        });
      
        if (ret.data.status === 200) {
          valor = ret.data.data;
      
          // 🔹 Palavras proibidas
          const palavrasBloqueadas = ["EQUIPAMENTOS - ", "CHECKLIST", "UNIMED", "UNIDADE", "BEBEDOURO", "BOMBA", "QUADRO", "HIDRÁULICA", "VERIFICAR", "TORNEIRA", "VERIFICAÇÃO"];
      
          // 🔹 Filtra os que NÃO contém nenhuma das palavras no loc_description
          const filtrado = valor.filter(
            (user: any) =>
              !palavrasBloqueadas.some((palavra) =>
                user.loc_description.toLowerCase().includes(palavra.toLowerCase())
              )
          );
      
          const arr = filtrado.map((user: any) => ({
            value: String(user.loc_id),
            label: `${user.loc_description} (${user.loc_alternativeidentifier})`,
          }));
      
          // 🔹 Ordena alfabeticamente pelo label
          arr.sort((a: any, b: any) =>
            a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
          );
      
          setOptionLocal(arr);
          setFiltroAtivo(true);
          setOpenModalIncluirNovo(false);
          setOpenModal(false);
        }
      } catch (e) {
        setOpenModal(false);
        setOpenModalIncluirNovo(false);
        setOptionLocal([]);
        setFiltroAtivo(true);
      }
      

    }

  }

  const handleOpenModal = () => {
    if (isMobile) {

      secureLocalStorage.removeItem('paramsEntidade')
      secureLocalStorage.removeItem('paramsQrcode')
      secureLocalStorage.removeItem('https')
      setIsModalOpen(true);
      setQualTitulo('Escanear QR Code')

    } else {

      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Este recurso está disponível apenas em dispositivos móveis.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);

    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };


  const uploadImg = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    const extensoesPermitidas = /\.(jpg|jpeg|png|gif)$/i;

    if (file) {
      if (extensoesPermitidas.test(file.name)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreviewUrl(reader.result as string);
        };
        reader.readAsDataURL(file);
      } else {
        e.target.value = '';
        setQualAlert(
          <div className="div-alert">
            <FaRegCircleXmark className="ControleIconAlertcancel" />
            <div className="div-info-alert-atencao">
              <span className="info-alert-atencao">ATENÇÃO</span>
            </div>
            <div className="div-info-alert">
              <span className="info-alert">
                Apenas arquivos JPG, JPEG, PNG e GIF são permitidos.
              </span>
            </div>
            <div className="btn-alert" onClick={fecharModal2}>
              <span className="btn-alert-lab">OK</span>
            </div>
          </div>
        );
        setOpenModal(true);
      }
    }
  };



  const uploadImg2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    const extensoesPermitidas = /\.(jpg|jpeg|png|gif)$/i;

    if (file) {
      if (extensoesPermitidas.test(file.name)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreviewUrl2(reader.result as string);
        };
        reader.readAsDataURL(file);
      } else {
        e.target.value = '';
        setQualAlert(
          <div className="div-alert">
            <FaRegCircleXmark className="ControleIconAlertcancel" />
            <div className="div-info-alert-atencao">
              <span className="info-alert-atencao">ATENÇÃO</span>
            </div>
            <div className="div-info-alert">
              <span className="info-alert">
                Apenas arquivos JPG, JPEG, PNG e GIF são permitidos.
              </span>
            </div>
            <div className="btn-alert" onClick={fecharModal2}>
              <span className="btn-alert-lab">OK</span>
            </div>
          </div>
        );
        setOpenModal(true);
      }
    }
  };

  function fecharModal2() {
    setOpenModal(false)
  }


  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      background: '#fff',
      minHeight: '35px',
      height: '35px',
      border: state.isFocused ? '1px solid #000000' : '1px solid #92989e', // Ajusta borda para 1px no foco
      boxShadow: 'none', // Remove qualquer sombra adicional no foco
      '&:hover': {
        borderColor: state.isFocused ? '#000000' : 'grey', // Cor da borda no hover
      },
    }),

    valueContainer: (provided: any, state: any) => ({
      ...provided,
      height: '35px',
      padding: '0 6px',

    }),

    input: (provided: any, state: any) => ({
      ...provided,
      margin: '0px',
      fontSize: 14,

    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      height: '35px',
    }),
  };

  function finalizarModal2() {
    setOpenModal(false)
  }


  function base64ToFile(base64Data: any, fileName: any) {
    const byteCharacters = atob(base64Data.split(',')[1]); // Decodifica a parte base64
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // Obtém o tipo de conteúdo
    const contentType = base64Data.split(';')[0].split(':')[1];

    // Cria um novo File a partir do Blob
    return new File([new Blob([byteNumbers], { type: contentType })], fileName, {
      type: contentType,
    });
  }

  async function ValidarAmbiente(event: React.FormEvent) {
    event.preventDefault();
  
    const ambiente = String(secureLocalStorage.getItem("tp") || "")
      .toLowerCase()
      .replace(/\s+/g, "");
  
    if (ambiente === "brasfort" || ambiente === "modelo") {
      const now = new Date();
      const offset = -3; // Horário de Brasília (UTC-3)
      const brazilDate = new Date(now.getTime() + offset * 60 * 60 * 1000);
  
      const hours = brazilDate.getUTCHours();
      const diaSemana = brazilDate.getUTCDay();
  
      // Regras
      const isHorarioNoturno = (h: number): boolean => h >= 17 || h < 7;
      const isFinalDeSemana = diaSemana === 0 || diaSemana === 6;
      const isFdsOuNoturno = isHorarioNoturno(hours) || isFinalDeSemana;
  
      const feriadosFixos = [
        "01-01", // Confraternização Universal
        "01-02",
        "02-16", //Carnaval
        "02-17", //Carnaval
        "02-18", //Carnaval
        "03-06", //carta magna
        "04-03", //paixão de cristo
        "04-21", // Tiradentes
        "05-01", // Dia do Trabalho
        "06-22", //são joão
        "06-23", //são joão
        "07-16", //
        "09-07", // Independência do Brasil
        "10-12", // Nossa Senhora Aparecida
        "11-02", // Finados
        "11-15", // Proclamação da República
        "11-20", // 
        "12-08",
        "12-25", // Natal
        "12-31", // Natal
      ];
  
      const mes = String(brazilDate.getUTCMonth() + 1).padStart(2, "0");
      const dia = String(brazilDate.getUTCDate()).padStart(2, "0");
      const hoje = `${mes}-${dia}`;
      const isFeriado = feriadosFixos.includes(hoje);

      // Condição final
      if (isFdsOuNoturno || isFeriado) {
        ConfirmarNoturno();
      } else {
        Confirmar();
      }
    } else {
      Confirmar();
    }
  }
  



  const STN_ABERTOS = '20,30,40';

  async function verificarChamadosAbertos(onProceed: () => void) {
    setQualAlert(<div className='div-alert'><Loading /></div>)
    setOpenModal(true)

    try {
      let ret: AxiosResponse;

      if (entidade === '1') {
        const localAtual = local;
        ret = await api.get('task/buscartask/local', {
          params: { loc_id: localAtual, stn_id: STN_ABERTOS }
        });
      } else {
        ret = await api.get('task/buscartask/asset', {
          params: { ast_id: ativo, stn_id: STN_ABERTOS }
        });
      }

      const chamados = ret.data?.data ?? [];


      if (chamados.length > 0) {
        setQualAlert(
          <div className='div-alert'>
            <FaRegCircleXmark className="ControleIconAlertcancel" />
            <div className='div-info-alert-atencao'>
              <span className="info-alert-atencao">ATENÇÃO</span>
            </div>
            <div className='div-info-alert'>
              <span className="info-alert">
                {chamados.length === 1
                  ? 'Já existe 1 chamado aberto'
                  : `Já existem ${chamados.length} chamados abertos`} para {entidade === '1' ? 'este local' : 'este ativo'}. Deseja continuar?
              </span>
            </div>
            <div style={{
              maxHeight: '220px',
              overflowY: 'auto',
              width: '100%',
              marginBottom: '16px',
              border: '1px solid #e0e0e0',
              borderRadius: '6px',
            }}>
              {chamados.map((item: any, idx: number) => (
                <div key={idx} style={{
                  padding: '10px 12px',
                  borderBottom: idx < chamados.length - 1 ? '1px solid #f0f0f0' : 'none',
                  textAlign: 'left',
                  fontSize: '13px',
                  backgroundColor: idx % 2 === 0 ? '#fafafa' : '#fff',
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                    <strong style={{ color: '#003D80', fontSize: '14px' }}>#{item.tsk_id}</strong>
                    <span style={{
                      backgroundColor: '#FFF3CD',
                      color: '#856404',
                      padding: '2px 8px',
                      borderRadius: '10px',
                      fontSize: '11px',
                      fontWeight: 600,
                    }}>{item.stn_description}</span>
                  </div>
                  <div style={{ color: '#333', marginBottom: '4px' }}>
                    {item.tsk_observation || 'Sem descrição'}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#888' }}>
                    <span>Solicitante: <strong style={{ color: '#555' }}>{item.age_login}</strong></span>
                    <span>{item.tsk_scheduleinitialdatehour}</span>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '8px' }}>
              <div
                onClick={() => { setOpenModal(false); onProceed(); }}
                style={{
                  background: 'linear-gradient(to right, #0076BE, #003D80)',
                  padding: '10px 24px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  transition: 'opacity 0.3s ease',
                  minWidth: '120px',
                  textAlign: 'center',
                }}
              >
                <span style={{ color: '#fff', fontWeight: 600, fontSize: '14px' }}>CONTINUAR</span>
              </div>
              <div
                onClick={finalizarModal2}
                style={{
                  background: '#6c757d',
                  padding: '10px 24px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  transition: 'opacity 0.3s ease',
                  minWidth: '120px',
                  textAlign: 'center',
                }}
              >
                <span style={{ color: '#fff', fontWeight: 600, fontSize: '14px' }}>CANCELAR</span>
              </div>
            </div>
          </div>
        );
        setOpenModal(true);
      } else {
        onProceed();
      }
    } catch {
      onProceed();
    }
  }

  async function ConfirmarNoturno() {

    console.log('ConfirmarNoturno')

    //event.preventDefault(); // Impede a atualização da página

    setQualAlert(<div className='div-alert'><Loading /></div>)
    setOpenModal(true)

    if (solicitante === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Insira o seu nome.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (local === '' && entidade === '1') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o local.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (ativo === '' && entidade === '2') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o ativo.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (entidade === '2' && tipoSolicitacao === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o tipo de solicitação.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );
      setOpenModal(true);
    } else if (entidade === '2' && tipoSolicitacao === '3' && localDestino === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o local de destino.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );
      setOpenModal(true);
    } else if (tipoSolicitacao === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o tipo de solicitação.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (observacao === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Por favor, descreva os detalhes do chamado que deseja abrir. Esse campo é obrigatório para prosseguir.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else {
      verificarChamadosAbertos(executarInsertNoturno);
    }
  }

  async function executarInsertNoturno() {
    setQualAlert(<div className='div-alert'><Loading /></div>)
    setOpenModal(true)

    if (imagePreviewUrl || imagePreviewUrl2) {

      const formData = new FormData();

      const endPoint = secureLocalStorage.getItem('endPoint')

      const ambiente = String(secureLocalStorage.getItem('tp') || '')
        .toLowerCase()
        .replace(/\s+/g, '');

      const ambienteString = typeof ambiente === 'string'
        ? ambiente.toLowerCase()
        : String(ambiente).toLowerCase();

      formData.append('ambiente', ambienteString);

      if (imagePreviewUrl) {
        const fileName = `${Date.now()}.png`;
        const file = base64ToFile(imagePreviewUrl, fileName);
        formData.append('files', file);
      }

      if (imagePreviewUrl2) {
        const fileName = `${Date.now()}2.png`;
        const file = base64ToFile(imagePreviewUrl2, fileName);
        formData.append('files', file);
      }

      const _user = secureLocalStorage.getItem('tpcm');
      api.defaults.headers.common['Authorization'] = _user as ''

      axios({
        method: "post",
        url: endPoint + 'upload',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      }).then(async function (response: any) {

        const newUuid = uuidv4()

        const now = new Date();
        const offset = -3;
        const brazilDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

        const year = brazilDate.getUTCFullYear();
        const month = String(brazilDate.getUTCMonth() + 1).padStart(2, "0");
        const day = String(brazilDate.getUTCDate()).padStart(2, "0");
        const hours = String(brazilDate.getUTCHours()).padStart(2, "0");
        const minutes = String(brazilDate.getUTCMinutes()).padStart(2, "0");
        const seconds = String(brazilDate.getUTCSeconds()).padStart(2, "0");

        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

        let localAtual = null

        if (entidade === '2' && tipoSolicitacao === '3') {
          localAtual = localDestino
        } else {
          localAtual = local
        }

        let agent = null;
        let team = null
        let forma = null

        if (age_id !== '') {
          agent = age_id
        } else {
          if(qualUnidade === '6' || qualUnidade === '11'){
            team = 4
            forma = 1
          }else if(qualUnidade === '9' || qualUnidade === '10'|| qualUnidade === '18'){
            team = 5
            forma = 1
          }else{
            team = null
            forma = null
          }
        }

        const dados = [{
          tsk_active: 1,
          tsk_recreate: 0,
          tsk_notification: 1,
          tty_id: tipoSolicitacao,
          age_id: agent || null,
          tea_id: team || null,
          tsf_id: forma || null,
          ast_id: ativo || null,
          tsk_integrationid: null,
          stn_id: 30,
          tsk_priority: null,
          src_id: 5,
          tsk_observation: observacao,
          tsk_responsible: secureLocalStorage.getItem('n'),
          tsk_requester: solicitante,
          tsk_telephone: telefone,
          tsk_agendadescription: null,
          agd_id: null,
          tsk_callback: null,
          tsk_frequency: null,
          crt_id: crt_id || null,
          pvt_id: null,
          tsk_technicalinstruction: null,
          tsk_image1: response?.data?.results?.[0]?.link || null,
          tsk_image2: response?.data?.results?.[1]?.link || null,
          ivb_id: null,
          tsk_scheduleinitialdatehour: formattedDate,
          tsk_schedulefinaldatehour: null,
          tsk_waitingtime: null,
          ctc_id: null,
          unt_id: null,
          loc_id: localAtual || null,
          tsk_userdestination: null,
          age_id_insert: secureLocalStorage.getItem('iag'),
          ett_id: entidade,
          tsk_accesstoken: newUuid,
        }]

        let ret: AxiosResponse;
        let dadosComp = [] as any

        const _user = secureLocalStorage.getItem('tpcm');
        api.defaults.headers.common['Authorization'] = _user as ''

        try {
          ret = await api.post("task/insert", {
            data: dados,
            dadosComp: dadosComp,
            dadosCampoCust: dadosCampoCust
          });
          if (ret.data.status === 200) {
            setAtivo("")
            setTipoSolicitacao("")
            setLocal('')
            setObservacao('')
            setLocalDestino('')
            setCrt_id('')
            setAge_id('')
            limparAnexos()
            setFiltroAtivo(false)

            setQualAlert(<div className='div-alert'>
              <FaCheckCircle className="ControleIconAlert" />
              <span className="fa-regular fa-circle-check ControleIconAlert"></span>
              <div className='btn-alert' onClick={finalizarModal3}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          }
        } catch (e: any) {
          setQualAlert(<div className='div-alert'>
            <FaRegCircleXmark className="ControleIconAlertcancel" />
            <div className='div-info-alert'><span className="info-alert">Não é possível criar a Tarefa.</span></div>
            <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
          </div>)
          setOpenModal(true)
        }

      })
        .catch(async function (error) {
          if (error.response === undefined) {
            setQualAlert(<div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Sem comunicação com o servidor.</span></div>
              <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          } else if (error.response.status === 403) {
            setQualAlert(<div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado.</span></div>
              <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          } else {
            setQualAlert(<div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Não foi possível concluir sua solicitação.</span></div>
              <div className='btn-alert' onClick={fecharModal2}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          }
        });

    } else {

      const newUuid = uuidv4()

      const now = new Date();
      const offset = -3;
      const brazilDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

      const year = brazilDate.getUTCFullYear();
      const month = String(brazilDate.getUTCMonth() + 1).padStart(2, "0");
      const day = String(brazilDate.getUTCDate()).padStart(2, "0");
      const hours = String(brazilDate.getUTCHours()).padStart(2, "0");
      const minutes = String(brazilDate.getUTCMinutes()).padStart(2, "0");
      const seconds = String(brazilDate.getUTCSeconds()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      let localAtual = null

      if (entidade === '2' && tipoSolicitacao === '3') {
        localAtual = localDestino
      } else {
        localAtual = local
      }

      let agent = null;
      let team = null
      let forma = null

      if (age_id !== '') {
        agent = age_id
      } else {
        if(qualUnidade === '6' || qualUnidade === '11'){
          team = 4
          forma = 1
        }else if(qualUnidade === '9' || qualUnidade === '10'|| qualUnidade === '18'){
          team = 5
          forma = 1
        }else{
          team = null
          forma = null
        }
      }

      const dados = [{
        tsk_active: 1,
        tsk_recreate: 0,
        tsk_notification: 1,
        tty_id: tipoSolicitacao,
        age_id: agent || null,
        tea_id: team || null,
        tsf_id: forma || null,
        ast_id: ativo || null,
        tsk_integrationid: null,
        stn_id: 30,
        tsk_priority: null,
        src_id: 5,
        tsk_observation: observacao,
        tsk_responsible: secureLocalStorage.getItem('n'),
        tsk_requester: solicitante,
        tsk_telephone: telefone,
        tsk_agendadescription: null,
        agd_id: null,
        tsk_callback: null,
        tsk_frequency: null,
        crt_id: crt_id || null,
        pvt_id: null,
        tsk_technicalinstruction: null,
        tsk_image1: null,
        tsk_image2: null,
        ivb_id: null,
        tsk_scheduleinitialdatehour: formattedDate,
        tsk_schedulefinaldatehour: null,
        tsk_waitingtime: null,
        ctc_id: null,
        unt_id: null,
        loc_id: localAtual || null,
        tsk_userdestination: null,
        age_id_insert: secureLocalStorage.getItem('iag'),
        ett_id: entidade,
        tsk_accesstoken: newUuid
      }]

      const _user = secureLocalStorage.getItem('tpcm');
      api.defaults.headers.common['Authorization'] = _user as ''

      let ret: AxiosResponse;
      let dadosComp = [] as any

      try {
        ret = await api.post("task/insert", {
          data: dados,
          dadosComp: dadosComp,
          dadosCampoCust: dadosCampoCust
        });
        if (ret.data.status === 200) {
          setAtivo("")
          setTipoSolicitacao("")
          setLocal('')
          setObservacao('')
          setLocalDestino('')
          setCrt_id('')
          setAge_id('')
          limparAnexos()
          setFiltroAtivo(false)

          setQualAlert(<div className='div-alert'>
            <FaCheckCircle className="ControleIconAlert" />
            <div className='div-info-alert'><span className="info-alert">Tarefa criada com sucesso.</span></div>
            <div className='btn-alert' onClick={finalizarModal3}><span className="btn-alert-lab">OK</span></div>
          </div>)
          setOpenModal(true)
        }
      } catch (e: any) {
        setQualAlert(<div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert'><span className="info-alert">Não é possível criar a Tarefa.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>)
        setOpenModal(true)
      }

    }
  }

  async function Confirmar() {

    //event.preventDefault(); // Impede a atualização da página

    setQualAlert(<div className='div-alert'><Loading /></div>)
    setOpenModal(true)

    if (solicitante === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Insira o seu nome.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (local === '' && entidade === '1') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o local.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (ativo === '' && entidade === '2') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o ativo.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (entidade === '2' && tipoSolicitacao === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o tipo de solicitação.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );
      setOpenModal(true);
    } else if (entidade === '2' && tipoSolicitacao === '3' && localDestino === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o local de destino.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );
      setOpenModal(true);
    } else if (tipoSolicitacao === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o tipo de solicitação.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else if (observacao === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Por favor, descreva os detalhes do chamado que deseja abrir. Esse campo é obrigatório para prosseguir.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else {
      verificarChamadosAbertos(executarInsertNormal);
    }
  }

  async function executarInsertNormal() {
    setQualAlert(<div className='div-alert'><Loading /></div>)
    setOpenModal(true)

    if (imagePreviewUrl || imagePreviewUrl2) {

      const formData = new FormData();

      const endPoint = secureLocalStorage.getItem('endPoint')

      const ambiente = String(secureLocalStorage.getItem('tp') || '')
        .toLowerCase()
        .replace(/\s+/g, '');

      const ambienteString = typeof ambiente === 'string'
        ? ambiente.toLowerCase()
        : String(ambiente).toLowerCase();

      formData.append('ambiente', ambienteString);

      if (imagePreviewUrl) {
        const fileName = `${Date.now()}.png`;
        const file = base64ToFile(imagePreviewUrl, fileName);
        formData.append('files', file);
      }

      if (imagePreviewUrl2) {
        const fileName = `${Date.now()}2.png`;
        const file = base64ToFile(imagePreviewUrl2, fileName);
        formData.append('files', file);
      }

      const _user = secureLocalStorage.getItem('tpcm');
      api.defaults.headers.common['Authorization'] = _user as ''

      axios({
        method: "post",
        url: endPoint + 'upload',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      }).then(async function (response: any) {

        const newUuid = uuidv4()

        const now = new Date();
        const offset = -3;
        const brazilDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

        const year = brazilDate.getUTCFullYear();
        const month = String(brazilDate.getUTCMonth() + 1).padStart(2, "0");
        const day = String(brazilDate.getUTCDate()).padStart(2, "0");
        const hours = String(brazilDate.getUTCHours()).padStart(2, "0");
        const minutes = String(brazilDate.getUTCMinutes()).padStart(2, "0");
        const seconds = String(brazilDate.getUTCSeconds()).padStart(2, "0");

        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

        const ambienteInsert = String(secureLocalStorage.getItem("tp") || "")
          .toLowerCase()
          .replace(/\s+/g, "");

        let agent = null;
        let team = null
        let forma = null
        let situacao = null

        if (age_id !== '') {
          agent = age_id
          situacao = 30
        } else {
          situacao = portalparameters[0]?.stn_id || null

          if (portalparameters[0]?.tea_id) {
            const contemCondicionado = descricaoAtivo
              ?.toLowerCase()
              .includes("condicionado");

            if (ambienteInsert === 'adlimmanutencao' && contemCondicionado === true){
              team = 2
              forma = 1
            } else {
              team = portalparameters[0]?.tea_id
              forma = 1
            }
          }

          if (portalparameters[0]?.age_id) {
            agent = portalparameters[0]?.age_id
          }
        }

        let localAtual = null

        if (entidade === '2' && tipoSolicitacao === '3') {
          localAtual = localDestino
        } else {
          localAtual = local
        }

        const dados = [{
          tsk_active: 1,
          tsk_recreate: 0,
          tsk_notification: 1,
          tty_id: tipoSolicitacao,
          age_id: agent || null,
          tea_id: team || null,
          tsf_id: forma || null,
          ast_id: ativo || null,
          tsk_integrationid: null,
          stn_id: situacao,
          tsk_priority: null,
          src_id: 5,
          tsk_observation: observacao,
          tsk_responsible: secureLocalStorage.getItem('n'),
          tsk_requester: solicitante,
          tsk_telephone: telefone,
          tsk_agendadescription: null,
          agd_id: null,
          tsk_callback: null,
          tsk_frequency: null,
          crt_id: crt_id || null,
          pvt_id: null,
          tsk_technicalinstruction: null,
          tsk_image1: response?.data?.results?.[0]?.link || null,
          tsk_image2: response?.data?.results?.[1]?.link || null,
          ivb_id: null,
          tsk_scheduleinitialdatehour: formattedDate,
          tsk_schedulefinaldatehour: null,
          tsk_waitingtime: null,
          ctc_id: null,
          unt_id: null,
          loc_id: localAtual || null,
          tsk_userdestination: null,
          age_id_insert: secureLocalStorage.getItem('iag'),
          ett_id: entidade,
          tsk_accesstoken: newUuid,
        }]

        let ret: AxiosResponse;
        let dadosComp = [] as any

        const _user = secureLocalStorage.getItem('tpcm');
        api.defaults.headers.common['Authorization'] = _user as ''

        try {
          ret = await api.post("task/insert", {
            data: dados,
            dadosComp: dadosComp,
            dadosCampoCust: dadosCampoCust
          });
          if (ret.data.status === 200) {
            setAtivo("")
            setTipoSolicitacao("")
            setLocal('')
            setObservacao('')
            setLocalDestino('')
            setCrt_id('')
            setAge_id('')
            limparAnexos()
            setFiltroAtivo(false)

            setQualAlert(<div className='div-alert'>
              <FaCheckCircle className="ControleIconAlert" />
              <div className='div-info-alert'><span className="info-alert">Tarefa criada com sucesso.</span></div>
              <div className='btn-alert' onClick={finalizarModal3}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          }
        } catch (e: any) {
          setQualAlert(<div className='div-alert'>
            <FaRegCircleXmark className="ControleIconAlertcancel" />
            <div className='div-info-alert'><span className="info-alert">Não é possível criar a Tarefa.</span></div>
            <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
          </div>)
          setOpenModal(true)
        }

      })
        .catch(async function (error) {
          if (error.response === undefined) {
            setQualAlert(<div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Sem comunicação com o servidor.</span></div>
              <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          } else if (error.response.status === 403) {
            setQualAlert(<div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado.</span></div>
              <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          } else {
            setQualAlert(<div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Não foi possível concluir sua solicitação.</span></div>
              <div className='btn-alert' onClick={fecharModal2}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
          }
        });

    } else {

      const newUuid = uuidv4()

      const now = new Date();
      const offset = -3;
      const brazilDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

      const year = brazilDate.getUTCFullYear();
      const month = String(brazilDate.getUTCMonth() + 1).padStart(2, "0");
      const day = String(brazilDate.getUTCDate()).padStart(2, "0");
      const hours = String(brazilDate.getUTCHours()).padStart(2, "0");
      const minutes = String(brazilDate.getUTCMinutes()).padStart(2, "0");
      const seconds = String(brazilDate.getUTCSeconds()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      const ambiente = String(secureLocalStorage.getItem("tp") || "")
        .toLowerCase()
        .replace(/\s+/g, "");

      let agent = null;
      let team = null
      let forma = null
      let situacao = null

      if (age_id !== '') {
        agent = age_id
        situacao = 30
      } else {
        situacao = portalparameters[0]?.stn_id

        if (portalparameters[0]?.tea_id) {
          const contemCondicionado = descricaoAtivo
            ?.toLowerCase()
            .includes("condicionado");

          if (ambiente === 'adlimmanutencao' && contemCondicionado === true){
            team = 2
            forma = 1
          } else {
            team = portalparameters[0]?.tea_id
            forma = 1
          }
        }

        if (portalparameters[0]?.age_id) {
          agent = portalparameters[0]?.age_id
        }
      }

      let localAtual = null

      if (entidade === '2' && tipoSolicitacao === '3') {
        localAtual = localDestino
      } else {
        localAtual = local
      }

      const dados = [{
        tsk_active: 1,
        tsk_recreate: 0,
        tsk_notification: 1,
        tty_id: tipoSolicitacao,
        age_id: agent || null,
        tea_id: team || null,
        tsf_id: forma || null,
        ast_id: ativo || null,
        tsk_integrationid: null,
        stn_id: situacao,
        tsk_priority: null,
        src_id: 5,
        tsk_observation: observacao,
        tsk_responsible: secureLocalStorage.getItem('n'),
        tsk_requester: solicitante,
        tsk_telephone: telefone,
        tsk_agendadescription: null,
        agd_id: null,
        tsk_callback: null,
        tsk_frequency: null,
        crt_id: crt_id || null,
        pvt_id: null,
        tsk_technicalinstruction: null,
        tsk_image1: null,
        tsk_image2: null,
        ivb_id: null,
        tsk_scheduleinitialdatehour: formattedDate,
        tsk_schedulefinaldatehour: null,
        tsk_waitingtime: null,
        ctc_id: null,
        unt_id: null,
        loc_id: localAtual || null,
        tsk_userdestination: null,
        age_id_insert: secureLocalStorage.getItem('iag'),
        ett_id: entidade,
        tsk_accesstoken: newUuid
      }]

      const _user = secureLocalStorage.getItem('tpcm');
      api.defaults.headers.common['Authorization'] = _user as ''

      let ret: AxiosResponse;
      let dadosComp = [] as any

      try {
        ret = await api.post("task/insert", {
          data: dados,
          dadosComp: dadosComp,
          dadosCampoCust: dadosCampoCust
        });
        if (ret.data.status === 200) {
          setAtivo("")
          setTipoSolicitacao("")
          setLocal('')
          setObservacao('')
          setLocalDestino('')
          setCrt_id('')
          setAge_id('')
          limparAnexos()
          setFiltroAtivo(false)

          setQualAlert(<div className='div-alert'>
            <FaCheckCircle className="ControleIconAlert" />
            <div className='div-info-alert'><span className="info-alert">Tarefa criada com sucesso.</span></div>
            <div className='btn-alert' onClick={finalizarModal3}><span className="btn-alert-lab">OK</span></div>
          </div>)
          setOpenModal(true)
        }
      } catch (e: any) {
        setQualAlert(<div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert'><span className="info-alert">Não é possível criar a Tarefa.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>)
        setOpenModal(true)
      }

    }
  }

  function finalizarModal3() {
    secureLocalStorage.removeItem('https')
    window.location.reload();
  }


  function fecharModal() {

    secureLocalStorage.removeItem('paramsEntidade')
    secureLocalStorage.removeItem('paramsQrcode')
    secureLocalStorage.removeItem('tpcm')
    secureLocalStorage.removeItem('acp')
    secureLocalStorage.removeItem('n')
    secureLocalStorage.removeItem('iag')
    secureLocalStorage.removeItem('aua')
    navigate('/login');
    setOpenModal(false)

  }

  function ChamarAtivo() {
    setDescricaoAtivo("")
    setEntidade('2')
    setOptionLocal(optionLocalComp)
    setOptionAtivo(optionAtivoComp)
    setLocal('')
    setAtivo('')
    setObservacao('')
    limparAnexos()
    setFiltroAtivo(false)
    setFiltroAtivo2(false)
    setTabIndex(1)
    setTipoSolicitacao("")
    setCrt_id('')
    setAge_id('')
    GetCorrectivetype('2')
    secureLocalStorage.removeItem('paramsEntidade')
    secureLocalStorage.removeItem('paramsQrcode')
    secureLocalStorage.removeItem('https')

    if (optionTipoSolicitacao.length === 1) {
      setTipoSolicitacao(optionTipoSolicitacao[0].value as any)
    }


  }

  function ChamarLocal() {
    setDescricaoAtivo("")
    setEntidade('1')
    setOptionAtivo(optionAtivoComp)
    setOptionLocal(optionLocalComp)
    setLocal('')
    setTipoSolicitacao("")
    setAtivo('')
    setCrt_id('')
    setAge_id('')
    setObservacao('')
    limparAnexos()
    setFiltroAtivo(false)
    setFiltroAtivo2(false)
    setTabIndex(0)
    GetCorrectivetype('1')
    secureLocalStorage.removeItem('paramsEntidade')
    secureLocalStorage.removeItem('paramsQrcode')
    secureLocalStorage.removeItem('https')

    if (optionTipoSolicitacao.length === 1) {
      setTipoSolicitacao(optionTipoSolicitacao[0].value as any)
    }

  }

  function abrirModalFiltro() {
    setOptionAndar([])
    setOptionLocal(optionLocalComp)
    setUnidade('');
    setAndar('');
    setLocal('');
    setContrato('');
    setQualTitulo('Filtro Avançado')
    setOpenModalIncluirNovo(true)
    secureLocalStorage.removeItem('paramsEntidade')
    secureLocalStorage.removeItem('paramsQrcode')
    secureLocalStorage.removeItem('https')
  }

  function fecharOpenModalIncluirNovo() {
    setOpenModalIncluirNovo(false)
  }

  const handleQrCodeDetected = (value: any) => {
    setIsModalOpen(false)
    setQrCodeValue(value);
    secureLocalStorage.removeItem('paramsEntidade')
    secureLocalStorage.removeItem('paramsQrcode')
    secureLocalStorage.removeItem('https')

    if (entidade === '1') {

      if (optionLocalCompleto.length > 0) {
        const qualAtv = optionLocalCompleto.filter(
          (e) => (e as any).loc_alternativeidentifier === value
        );

        if (qualAtv.length > 0) {
          setLocal(String((qualAtv[0] as any).loc_id));
        } else {
          setQualAlert(
            <div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Local não encontrado.</span></div>
              <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
            </div>
          );

          setOpenModal(true);
        }
      }

    } else if (entidade === '2') {

      if (optionAtivoCompleto.length > 0) {
        const qualAtv = optionAtivoCompleto.filter(
          (e) => (e as any).ast_alternativeidentifier === value
        );

        if (qualAtv.length > 0) {

          setAtivo(String((qualAtv[0] as any).ast_id));

        } else {
          setQualAlert(
            <div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Ativo não encontrado.</span></div>
              <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
            </div>
          );

          setOpenModal(true);
        }
      }

    }



  };

  function alternarFiltro() {
    setUnidade("")
    setAndar("")
    setLocal("")
    secureLocalStorage.removeItem('paramsEntidade')
    secureLocalStorage.removeItem('paramsQrcode')
    secureLocalStorage.removeItem('https')
    setLocal('')
    setOptionLocal(optionLocalComp)
    setFiltroAtivo(false)
  }


  function alternarFiltro2() {
    setOptionUnidade([])
    setOptionAndar([])
    setUnidade("")
    setAndar("")
    setLocal("")
    setLocalFiltro("")
    secureLocalStorage.removeItem('https')
    setAtivo('')
    setOptionAtivo(optionAtivoComp)
    setFiltroAtivo2(false)
  }

  function limparAnexos() {

    setImagePreviewUrl("")
    setImagePreviewUrl2("")
    const fileInput = document.getElementById("fileInput") as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }

    const fileInput2 = document.getElementById("fileInput2") as HTMLInputElement;
    if (fileInput2) {
      fileInput2.value = "";
    }
  }

  //--------------------filtros ativos------------------------------------------

  function abrirModalFiltroAtivo() {
    secureLocalStorage.removeItem('https')
    setOptionAndar([])
    setOptionLocal([])
    setUnidade('');
    setAndar('');
    setLocal('')
    setAtivo('')
    setContrato('')
    setLocalFiltro("")
    setQualTitulo('Filtro Avançado')
    setOpenModalIncluirNovo2(true)
    GetLocalAtivo()
  }


  function fecharOpenModalIncluirNovo2() {
    setOpenModalIncluirNovo2(false)
  }


  function setarAndar(id: any) {

    if (id === '') {
      setOptionLocal([])
      setAndar('');
      setLocal('');
      setLocalFiltro('');
    } else {
      setOptionLocal([])
      setLocalFiltro('');
      setLocal('');
      setAndar(id)
      GetLocalAndarFilter(id)
    }
  }


  async function GetLocalAndarFilter(id: any) {
    let ret: AxiosResponse;
    let valor: any;
  
    setQualAlert(<div className='div-alert'><Loading /></div>);
    setOpenModal(true);
  
    try {
      ret = await api.get("local/listarlocpaviment", {
        params: {
          id: unidade,
          paviment: id,
        },
      });
  
      if (ret.data.status === 200) {
        valor = ret.data.data;
  

        // 🔹 Palavras proibidas
        const palavrasBloqueadas = ["CHECKLIST", "UNIMED", "UNIDADE", "BEBEDOURO", "BOMBA", "QUADRO", "HIDRÁULICA", "VERIFICAR", "TORNEIRA", "VERIFICAÇÃO"];
  
        // 🔹 Filtra os que NÃO contêm nenhuma das palavras no loc_description
        const filtrado = valor.filter(
          (user: any) =>
            !palavrasBloqueadas.some((palavra) =>
              user.loc_description.toLowerCase().includes(palavra.toLowerCase())
            )
        );
  
        const arr = filtrado.map((user: any) => ({
          value: String(user.loc_id),
          label: user.loc_description,
        }));
  
        // 🔹 Ordena em ordem alfabética pelo label
        arr.sort((a: any, b: any) =>
          a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
        );
  
        setOptionLocal(arr);
        setOpenModal(false);
      }
    } catch (e) {
      setOpenModal(false);
      setOptionLocal([]);
    }
  }
  

  async function GetLocalAtivo() {
    let ret: AxiosResponse;
    let valor: any;
  
    setQualAlert(<div className='div-alert'><Loading /></div>);
    setOpenModal(true);
  
    try {
      ret = await api.get("local/listarlocal");
      if (ret.data.status === 200) {
        valor = ret.data.data;
  
        // 🔹 Palavras proibidas
        const palavrasBloqueadas = ["EQUIPAMENTOS - ", "CHECKLIST", "UNIMED", "UNIDADE", "BEBEDOURO", "BOMBA", "QUADRO", "HIDRÁULICA", "VERIFICAR", "TORNEIRA", "VERIFICAÇÃO"];
  
        // 🔹 Filtra os que NÃO contêm nenhuma das palavras no loc_description
        const filtrado = valor.filter(
          (user: any) =>
            !palavrasBloqueadas.some((palavra) =>
              user.loc_description.toLowerCase().includes(palavra.toLowerCase())
            )
        );
  
        const arr = filtrado.map((user: any) => ({
          value: String(user.loc_id),
          label: user.loc_description,
        }));
  
        // 🔹 Ordena em ordem alfabética pelo label
        arr.sort((a: any, b: any) =>
          a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
        );
  
        setOpenModal(false);
        setOptionLocal(arr);
      } else {
        setOptionLocal([]);
      }
    } catch (e) {
      setOpenModal(false);
      setOptionLocal([]);
    }
  }
  

  function IncluirUnidadeAtivo(id: any) {
    if (id === '') {
      setOptionAndar([]);
      setOptionLocal([]);
      setUnidade('');
      setAndar('');
      setLocal('')
      setLocal('');
      setLocalFiltro('');
    } else {
      setLocal('')
      setAndar('');
      setLocal('');
      setLocalFiltro('');
      setOptionAndar([]);
      setOptionLocal([]);
      GetPavimento(id);
      setUnidade(id);
    }
  }

  async function GetAtivoLocal() {
    let ret: AxiosResponse;
    let valor: any;



    if (localFiltro === '') {
      setQualAlert(
        <div className='div-alert'>
          <FaRegCircleXmark className="ControleIconAlertcancel" />
          <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
          <div className='div-info-alert'><span className="info-alert">Selecione o local.</span></div>
          <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
        </div>
      );

      setOpenModal(true);
    } else {

      setQualAlert(<div className='div-alert'><Loading /></div>)
      setOpenModal(true)

      try {
        ret = await api.get("local/listarativoloc", {
          params: {
            id: localFiltro
          }
        })
        if (ret.data.status === 200) {
          valor = ret.data.data;

          const arr = [] as any;
          let result = valor;
          result.map((user: any) => {
            return arr.push({ value: String(user.ast_id), label: user.ast_alternativeidentifier ? user.ast_description + " (" + user.ast_alternativeidentifier + ")" : user.ast_description });
          });

          setOptionAtivo(arr)
          setLocal('')
          setOptionLocal(optionLocalComp)
          setFiltroAtivo2(true)
          setOpenModalIncluirNovo2(false)
          setOpenModal(false)
        } else {
          setOpenModal(false)
          setQualAlert(
            <div className='div-alert'>
              <FaRegCircleXmark className="ControleIconAlertcancel" />
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Não foram encontrados ativos vinculados a este local.</span></div>
              <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
            </div>
          );

          setOpenModal(true);
        }

      } catch (e) {

        setFiltroAtivo2(true)
        setOpenModal(false)
        setOptionAtivo([])
        setQualAlert(
          <div className='div-alert'>
            <FaRegCircleXmark className="ControleIconAlertcancel" />
            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
            <div className='div-info-alert'><span className="info-alert">Não foi possível completar a requisição.</span></div>
            <div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
          </div>
        );

        setOpenModal(true);
      }
    }

  }

  function IncluirSolicitacao(id: any) {

    if (id === '') {
      setTipoSolicitacao("")
    } else {
      setTipoSolicitacao(id)
    }
  }

  function incluirDadosCamposCust(dados: any) {
    setDadosCampoCust(dados)
  }


  function setincluirAtivo(id: any) {

    if (id === '') {

      setAtivo('')
      setDescricaoAtivo('')

    } else {

      const onde = optionAtivoAtual.find(
        (e: any) => String(e.ast_id) === String(id)
      );

      setqualUnidade(String(onde?.unt_id));
      setDescricaoAtivo((onde?.ast_description || ''));

      setAtivo(id)  
    }
  }


  return (
    <>
      <div className="chamados-container">
        <Header />
        <div className="chamados-main">

          <div className="header-container">
            <div className="line"></div>
            <div className="icon-circle">
              <MdQrCodeScanner className="qrcode-icon" onClick={handleOpenModal} />
            </div>
            <div className="line"></div>
          </div>

          <div className="chamados-card">

            <div className="card-tab">
              <div className="card-header">

                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>

                  <div className="container-cad2">
                    <TabList>

                      <Tab onClick={ChamarLocal}>
                        <p>Local</p>
                      </Tab>


                      <Tab onClick={ChamarAtivo}>
                        <p>Ativo</p>
                      </Tab>

                    </TabList>


                  </div>

                  <div className="container-cad2">
                    <TabPanel>
                      <div className="panel-content">

                        <div className="form-chamados">
                          <form className="chamados-form">
                            {/* <div className="form-group">
                              <label>Empresa: *</label>
                              <Select
                                maxMenuHeight={140}
                                placeholder={'Selecione...'}
                                options={optionEmpresa}
                                value={optionEmpresa.filter(function (option: any) {
                                  return option.value === empresa;
                                })}
                                onChange={(options: any) =>
                                  !options ? setEmpresa("") : setEmpresa(options.value)
                                }
                                styles={customStyles}
                                isClearable
                                noOptionsMessage={() => "Não encontrado..."}
                                theme={(theme: any) => ({
                                  ...theme,
                                  borderRadius: 4,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#ebebeb',
                                    primary: 'black',
                                  },
                                })}
                              />
                            </div>
                            */}
                            <div className="container-cad1">
                              <div id="content1">
                                <div className="form-group">
                                  <label>Solicitante: *</label>
                                  <input type="text" placeholder="Digite seu nome"
                                    onChange={(e) => setSolicitante(e.target.value)}
                                    value={solicitante} />
                                </div>
                              </div>
                              <div id="content2">
                                <div className="form-group">
                                  <label>Telefone:</label>
                                  <input type="text"
                                    placeholder="Digite seu telefone"
                                    onChange={(e) => setTelefone(e.target.value)}
                                    value={telefone} />
                                </div>
                              </div>
                            </div>


                            <div className="form-group">
                              <label>
                                Local: *
                              </label>

                              <div className="filtro-avancado">

                                <div className="filtro-avancado-select">
                                  <Select
                                    maxMenuHeight={140}
                                    placeholder={'Selecione...'}
                                    options={optionLocal}
                                    value={optionLocal.filter(function (option: any) {
                                      return option.value === local;
                                    })}
                                    onChange={(options: any) =>
                                      !options ? incluirLocal("") : incluirLocal(options.value)
                                    }
                                    styles={customStyles}
                                    isClearable
                                    noOptionsMessage={() => "Não encontrado..."}
                                    theme={(theme: any) => ({
                                      ...theme,
                                      borderRadius: 4,
                                      colors: {
                                        ...theme.colors,
                                        primary25: '#ebebeb',
                                        primary: 'black',
                                      },
                                    })}
                                  />
                                </div>

                                {filtroAtivo ? (
                                  <div className="filtro-avancado-btn" onClick={alternarFiltro}>
                                    <MdFilterAltOff
                                      className="btn-filter-remover"
                                      onClick={alternarFiltro}
                                      title="Filtro ativo"
                                    />
                                  </div>
                                ) : (
                                  <div className="filtro-avancado-btn" onClick={abrirModalFiltro}>
                                    <FaFilter
                                      className="btn-filter"
                                      onClick={abrirModalFiltro}
                                      title="Sem filtro"
                                    />
                                  </div>
                                )}

                              </div>

                            </div>

                            <div className="form-group">
                              <label>Tipo de Solicitação: *</label>
                              <Select
                                maxMenuHeight={140}
                                placeholder={'Selecione...'}
                                options={optionTipoSolicitacao}
                                value={optionTipoSolicitacao.filter(function (option: any) {
                                  return option.value === tipoSolicitacao;
                                })}
                                onChange={(options: any) =>
                                  !options ? IncluirSolicitacao("") : IncluirSolicitacao(options.value)
                                }
                                styles={customStyles}
                                isClearable
                                noOptionsMessage={() => "Não encontrado..."}
                                theme={(theme: any) => ({
                                  ...theme,
                                  borderRadius: 4,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#ebebeb',
                                    primary: 'black',
                                  },
                                })}
                              />
                            </div>


                            {secureLocalStorage.getItem("aua") === 1 &&
                              (
                                <div className="form-group">
                                  <label>Técnico: </label>
                                  <Select
                                    maxMenuHeight={140}
                                    placeholder={'Selecione...'}
                                    options={optionsAgent}
                                    value={optionsAgent.filter((option: any) => option.value === age_id)}
                                    onChange={(options: any) =>
                                      !options ? setAge_id("") : setAge_id(options.value)
                                    }
                                    styles={customStyles}
                                    isClearable
                                    noOptionsMessage={() => "Não encontrado..."}
                                    theme={(theme: any) => ({
                                      ...theme,
                                      borderRadius: 4,
                                      colors: {
                                        ...theme.colors,
                                        primary25: '#ebebeb',
                                        primary: 'black',
                                      },
                                    })}
                                  />
                                </div>
                              )}


                            {secureLocalStorage.getItem("aua") === 1 &&
                              tipoSolicitacao === "2" && (
                                <div className="form-group">
                                  <label>Tipo Corretiva: </label>
                                  <Select
                                    maxMenuHeight={140}
                                    placeholder={'Selecione...'}
                                    options={optionsCorrectivetype}
                                    value={optionsCorrectivetype.filter((option: any) => option.value === crt_id)}
                                    onChange={(options: any) =>
                                      !options ? setCrt_id("") : setCrt_id(options.value)
                                    }
                                    styles={customStyles}
                                    isClearable
                                    noOptionsMessage={() => "Não encontrado..."}
                                    theme={(theme: any) => ({
                                      ...theme,
                                      borderRadius: 4,
                                      colors: {
                                        ...theme.colors,
                                        primary25: '#ebebeb',
                                        primary: 'black',
                                      },
                                    })}
                                  />
                                </div>
                              )}



                            <div className="form-group">
                              <label>Observação: *</label>
                              <textarea className="inp-textarea" placeholder="Digite uma observação"
                                onChange={(e) => setObservacao(e.target.value)}
                                value={observacao}
                              ></textarea>
                            </div>

                            <InputCustTask incluirDadosCamposCust={incluirDadosCamposCust} />

                            <div className="btn-escolha">
                              <input
                                type="file"
                                id="fileInput"
                                onChange={uploadImg}
                              />
                            </div>

                            <div className="btn-escolha">
                              <input
                                type="file"
                                id="fileInput2"
                                onChange={(e) => {
                                  uploadImg2(e);
                                }}
                              />
                            </div>

                            <div className="btn-container">
                              <button type="submit" className="btn-enviar" onClick={ValidarAmbiente}>Enviar</button>
                            </div>

                          </form>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="panel-content">
                        <div className="form-chamados">
                          <form className="chamados-form">
                            {/*<div className="form-group">
                              <label>Empresa: *</label>
                              <Select
                                maxMenuHeight={140}
                                placeholder={'Selecione...'}
                                options={optionEmpresa}
                                value={optionEmpresa.filter(function (option: any) {
                                  return option.value === empresa;
                                })}
                                onChange={(options: any) =>
                                  !options ? setEmpresa("") : setEmpresa(options.value)
                                }
                                styles={customStyles}
                                isClearable
                                noOptionsMessage={() => "Não encontrado..."}
                                theme={(theme: any) => ({
                                  ...theme,
                                  borderRadius: 4,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#ebebeb',
                                    primary: 'black',
                                  },
                                })}
                              />
                            </div>*/}
                            <div className="container-cad1">
                              <div id="content1">
                                <div className="form-group">
                                  <label>Solicitante: *</label>
                                  <input type="text" placeholder="Digite seu nome"
                                    onChange={(e) => setSolicitante(e.target.value)}
                                    value={solicitante} />
                                </div>
                              </div>
                              <div id="content2">
                                <div className="form-group">
                                  <label>Telefone:</label>
                                  <input type="text"
                                    placeholder="Digite seu telefone"
                                    onChange={(e) => setTelefone(e.target.value)}
                                    value={telefone} />
                                </div>
                              </div>
                            </div>


                            <div className="form-group">
                              <label>
                                Ativo: *
                              </label>

                              <div className="filtro-avancado">

                                <div className="filtro-avancado-select">
                                  <Select
                                    maxMenuHeight={140}
                                    placeholder={'Selecione...'}
                                    options={optionAtivo}
                                    value={optionAtivo.filter(function (option: any) {
                                      return option.value === ativo;
                                    })}
                                    onChange={(options: any) =>
                                      !options ? setincluirAtivo("") : setincluirAtivo(options.value)
                                    }
                                    styles={customStyles}
                                    isClearable
                                    noOptionsMessage={() => "Não encontrado..."}
                                    theme={(theme: any) => ({
                                      ...theme,
                                      borderRadius: 4,
                                      colors: {
                                        ...theme.colors,
                                        primary25: '#ebebeb',
                                        primary: 'black',
                                      },
                                    })}
                                  />
                                </div>

                                {filtroAtivo2 ? (
                                  <div className="filtro-avancado-btn" onClick={alternarFiltro2}>
                                    <MdFilterAltOff
                                      className="btn-filter-remover"
                                      onClick={alternarFiltro2}
                                      title="Filtro ativo"
                                    />
                                  </div>
                                ) : (
                                  <div className="filtro-avancado-btn" onClick={abrirModalFiltroAtivo}>
                                    <FaFilter
                                      className="btn-filter"
                                      onClick={abrirModalFiltroAtivo}
                                      title="Sem filtro"
                                    />
                                  </div>
                                )}

                              </div>

                            </div>



                            <div className="form-group">
                              <label>Tipo de Solicitação: *</label>
                              <Select
                                maxMenuHeight={140}
                                placeholder={'Selecione...'}
                                options={optionTipoSolicitacao}
                                value={optionTipoSolicitacao.filter(function (option: any) {
                                  return option.value === tipoSolicitacao;
                                })}
                                onChange={(options: any) =>
                                  !options ? IncluirSolicitacao("") : IncluirSolicitacao(options.value)
                                }
                                styles={customStyles}
                                isClearable
                                noOptionsMessage={() => "Não encontrado..."}
                                theme={(theme: any) => ({
                                  ...theme,
                                  borderRadius: 4,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#ebebeb',
                                    primary: 'black',
                                  },
                                })}
                              />
                            </div>


                            {secureLocalStorage.getItem("aua") === 1 &&
                              (
                                <div className="form-group">
                                  <label>Técnico: </label>
                                  <Select
                                    maxMenuHeight={140}
                                    placeholder={'Selecione...'}
                                    options={optionsAgent}
                                    value={optionsAgent.filter((option: any) => option.value === age_id)}
                                    onChange={(options: any) =>
                                      !options ? setAge_id("") : setAge_id(options.value)
                                    }
                                    styles={customStyles}
                                    isClearable
                                    noOptionsMessage={() => "Não encontrado..."}
                                    theme={(theme: any) => ({
                                      ...theme,
                                      borderRadius: 4,
                                      colors: {
                                        ...theme.colors,
                                        primary25: '#ebebeb',
                                        primary: 'black',
                                      },
                                    })}
                                  />
                                </div>
                              )}


                            {secureLocalStorage.getItem("aua") === 1 &&
                              tipoSolicitacao === "2" && (
                                <div className="form-group">
                                  <label>Tipo Corretiva: </label>
                                  <Select
                                    maxMenuHeight={140}
                                    placeholder={'Selecione...'}
                                    options={optionsCorrectivetype}
                                    value={optionsCorrectivetype.filter((option: any) => option.value === crt_id)}
                                    onChange={(options: any) =>
                                      !options ? setCrt_id("") : setCrt_id(options.value)
                                    }
                                    styles={customStyles}
                                    isClearable
                                    noOptionsMessage={() => "Não encontrado..."}
                                    theme={(theme: any) => ({
                                      ...theme,
                                      borderRadius: 4,
                                      colors: {
                                        ...theme.colors,
                                        primary25: '#ebebeb',
                                        primary: 'black',
                                      },
                                    })}
                                  />
                                </div>
                              )}


                            {tipoSolicitacao === '3' ? (
                              <div className="form-group">
                                <label>
                                  Local de Destino: *
                                </label>
                                <div className="filtro-avancado">
                                  <div className="filtro-avancado-select">
                                    <Select
                                      maxMenuHeight={140}
                                      placeholder={'Selecione...'}
                                      options={optionLocal}
                                      value={optionLocal.filter(function (option: any) {
                                        return option.value === localDestino;
                                      })}
                                      onChange={(options: any) =>
                                        !options ? setLocalDestino("") : setLocalDestino(options.value)
                                      }
                                      styles={customStyles}
                                      isClearable
                                      noOptionsMessage={() => "Não encontrado..."}
                                      theme={(theme: any) => ({
                                        ...theme,
                                        borderRadius: 4,
                                        colors: {
                                          ...theme.colors,
                                          primary25: '#ebebeb',
                                          primary: 'black',
                                        },
                                      })}
                                    />
                                  </div>

                                  {filtroAtivo ? (
                                    <div className="filtro-avancado-btn" onClick={alternarFiltro}>
                                      <MdFilterAltOff
                                        className="btn-filter-remover"
                                        onClick={alternarFiltro}
                                        title="Filtro ativo"
                                      />
                                    </div>
                                  ) : (
                                    <div className="filtro-avancado-btn" onClick={abrirModalFiltro}>
                                      <FaFilter
                                        className="btn-filter"
                                        onClick={abrirModalFiltro}
                                        title="Sem filtro"
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            ) : (null)}

                            <div className="form-group">
                              <label>Observação: *</label>
                              <textarea className="inp-textarea" placeholder="Digite uma observação"
                                onChange={(e) => setObservacao(e.target.value)}
                                value={observacao}
                              ></textarea>
                            </div>

                            <InputCustTask incluirDadosCamposCust={incluirDadosCamposCust} />

                            <div className="btn-escolha">
                              <input
                                type="file"
                                id="fileInput"
                                onChange={uploadImg}
                              />
                            </div>

                            <div className="btn-escolha">
                              <input
                                type="file"
                                id="fileInput2"
                                onChange={(e) => {
                                  uploadImg2(e);
                                }}
                              />
                            </div>

                            <div className="btn-container">
                              <button type="submit" className="btn-enviar" onClick={ValidarAmbiente}>Enviar</button>
                            </div>

                          </form>
                        </div>
                      </div>
                    </TabPanel>
                  </div>

                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalAlert isOpen={isModalOpen} setModalOpen={() => handleCloseModal()}>


        <div className='title-modal-incluir'>
          <h1 className="modal-IncluirNovo-title">{qualTitulo}</h1>
          <div onClick={handleCloseModal}>
            <button className="fa fa-times icone-modal-IncluirNovo" data-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>

        <div className='container-modal-alert'>
          <QRCodeScanner
            modalOpen={isModalOpen}
            onQrCodeDetected={handleQrCodeDetected}
            onClose={() => setIsModalOpen(false)}
          />
        </div>
      </ModalAlert>


      <ModalIncluirNovo isOpen={openModalIncluirNovo} setModalOpen={() => setOpenModalIncluirNovo(!openModalIncluirNovo)}>
        <>
          <div className='title-modal-incluir'>
            <h1 className="modal-IncluirNovo-title">{qualTitulo}</h1>
            <div onClick={fecharOpenModalIncluirNovo}>
              <button className="fa fa-times icone-modal-IncluirNovo" data-dismiss="modal" aria-label="Close"></button>
            </div>
          </div>

          <div className='scrol-modal2'>
            <div className="form-group-modale">
              <label>Contrato: </label>
              <Select
                maxMenuHeight={180}
                placeholder={'Selecione...'}
                options={optionContrato}
                isDisabled={isDisabledContrato}
                value={optionContrato.filter(function (option: any) {
                  return option.value === contrato;
                })}
                onChange={(options: any) =>
                  !options ? IncluirContrato("") : IncluirContrato(options.value)
                }
                styles={customStyles}
                isClearable
                noOptionsMessage={() => "Não encontrado..."}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    primary25: '#ebebeb',
                    primary: 'black',
                  },
                })}
              />
            </div>




            <div className="form-group-modale">
              <label>Unidade: </label>
              <Select
                maxMenuHeight={190}
                placeholder={'Selecione...'}
                options={optionUnidade}
                value={optionUnidade.filter(function (option: any) {
                  return option.value === unidade;
                })}
                onChange={(options: any) =>
                  !options ? IncluirUnidade("") : IncluirUnidade(options.value)
                }
                styles={customStyles}
                isClearable
                noOptionsMessage={() => "Não encontrado..."}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    primary25: '#ebebeb',
                    primary: 'black',
                  },
                })}
              />
            </div>




            <div className="form-group-modale">
              <label>Razão Social / Pavimento: </label>
              <Select
                maxMenuHeight={120}
                placeholder={'Selecione...'}
                options={optionAndar}
                value={optionAndar.filter(function (option: any) {
                  return option.value === andar;
                })}
                onChange={(options: any) =>
                  !options ? setAndar("") : setAndar(options.value)
                }
                styles={customStyles}
                isClearable
                noOptionsMessage={() => "Não encontrado..."}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    primary25: '#ebebeb',
                    primary: 'black',
                  },
                })}
              />
            </div>

            <div className="btn-container2">
              <button type="submit" className="btn-enviar" onClick={GetLocalAndar}>Filtrar</button>
            </div>

          </div>

        </>
      </ModalIncluirNovo>

      <ModalIncluirNovo isOpen={openModalIncluirNovo2} setModalOpen={() => setOpenModalIncluirNovo2(!openModalIncluirNovo2)}>
        <>
          <div className='title-modal-incluir'>
            <h1 className="modal-IncluirNovo-title">{qualTitulo}</h1>
            <div onClick={fecharOpenModalIncluirNovo2}>
              <button className="fa fa-times icone-modal-IncluirNovo" data-dismiss="modal" aria-label="Close"></button>
            </div>
          </div>

          <div className='scrol-modal'>
            <div className="form-group-modale">
              <label>Contrato: </label>
              <Select
                maxMenuHeight={180}
                placeholder={'Selecione...'}
                options={optionContrato}
                isDisabled={isDisabledContrato}
                value={optionContrato.filter(function (option: any) {
                  return option.value === contrato;
                })}
                onChange={(options: any) =>
                  !options ? IncluirContrato("") : IncluirContrato(options.value)
                }
                styles={customStyles}
                isClearable
                noOptionsMessage={() => "Não encontrado..."}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    primary25: '#ebebeb',
                    primary: 'black',
                  },
                })}
              />
            </div>

            <div className="form-group-modale">
              <label>Unidade: </label>
              <Select
                maxMenuHeight={180}
                placeholder={'Selecione...'}
                options={optionUnidade}
                value={optionUnidade.filter(function (option: any) {
                  return option.value === unidade;
                })}
                onChange={(options: any) =>
                  !options ? IncluirUnidadeAtivo("") : IncluirUnidadeAtivo(options.value)
                }
                styles={customStyles}
                isClearable
                noOptionsMessage={() => "Não encontrado..."}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    primary25: '#ebebeb',
                    primary: 'black',
                  },
                })}
              />
            </div>

            <div className="form-group-modale">
              <label>Razão Social / Pavimento: </label>
              <Select
                maxMenuHeight={160}
                placeholder={'Selecione...'}
                options={optionAndar}
                value={optionAndar.filter(function (option: any) {
                  return option.value === andar;
                })}
                onChange={(options: any) =>
                  !options ? setarAndar("") : setarAndar(options.value)
                }
                styles={customStyles}
                isClearable
                noOptionsMessage={() => "Não encontrado..."}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    primary25: '#ebebeb',
                    primary: 'black',
                  },
                })}
              />
            </div>

            <div className="form-group-modale">
              <label>Local: *</label>
              <Select
                maxMenuHeight={138}
                placeholder={'Selecione...'}
                options={optionLocal}
                value={optionLocal.filter(function (option: any) {
                  return option.value === localFiltro;
                })}
                onChange={(options: any) =>
                  !options ? setLocalFiltro("") : setLocalFiltro(options.value)
                }
                styles={customStyles}
                isClearable
                noOptionsMessage={() => "Não encontrado..."}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 4,
                  colors: {
                    ...theme.colors,
                    primary25: '#ebebeb',
                    primary: 'black',
                  },
                })}
              />
            </div>



            <div className="btn-container2">
              <button type="submit" className="btn-enviar" onClick={GetAtivoLocal}>Filtrar</button>
            </div>

          </div>

        </>
      </ModalIncluirNovo>

      <ModalAlert isOpen={openModal} setModalOpen={() => setOpenModal(!openModal)}>
        <div className='container-modal-alert'>
          {qualAlert}
        </div>
      </ModalAlert>

    </>
  );
};

export default Chamados;
